// src/components/layouts/renderers/FactQuoteFrame.tsx
import React from 'react';
import { AbsoluteFill } from 'remotion';
import type { FactQuoteConfig, LayoutRendererProps } from '@/lib/layouts/types';
import { layoutHeadlineCss, SYSTEM_SANS } from '@/lib/layouts/headlineStyle';
import { useLayerFont } from '@/hooks/use-layer-font';

export const FactQuoteFrame: React.FC<LayoutRendererProps<FactQuoteConfig>> = ({ config, media }) => {
  useLayerFont(config.headlineFontFamily, config.headlineFontUrl);
  const headline = (
    <div
      data-testid="fq-headline"
      data-autocut-over=""
      style={{
        fontWeight: 800,
        lineHeight: 1.18,
        textShadow: '0 2px 12px rgba(0,0,0,0.5)',
        ...layoutHeadlineCss(
          { ...config, headlineColor: config.headlineColor ?? config.textColor },
          { color: config.textColor, fontSize: 72, fontFamily: SYSTEM_SANS },
        ),
      }}
    >
      {config.headline}
    </div>
  );
  return (
    <AbsoluteFill>
      <AbsoluteFill style={{ backgroundColor: '#000' }}>{media}</AbsoluteFill>
      <AbsoluteFill data-autocut-over="" style={{ background: `linear-gradient(to bottom, transparent 35%, ${config.scrimColor} 100%)` }} />
      {config.headlineAnchor ? (
        <AbsoluteFill>{headline}</AbsoluteFill>
      ) : (
        <AbsoluteFill style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-start', padding: 70 }}>
          {headline}
        </AbsoluteFill>
      )}
    </AbsoluteFill>
  );
};
